import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../styles/Cards.css';

const Cards = () => {
  const [isVisible, setIsVisible] = useState(false);

  const [announcements, setAnnouncements] = useState([]);
  const [events, setEvents] = useState([]);
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      const res = await axios.get('https://college-website-backend-316h.onrender.com/api/notices');
      const notices = res.data.data;

      // Categorize notices
      setAnnouncements(
        notices
          .filter(n => n.category === 'Exam')
          .map(n => n.title)
      );

      setEvents(
        notices
          .filter(n => n.category === 'Event')
          .map(n => n.title)
      );

      setUpdates(
        notices
          .filter(n => n.category === 'General')
          .map(n => n.title)
      );
    } catch (error) {
      console.error('Failed to fetch notices:', error);
    }
  };

  const stopAutoScroll = (e) => {
    e.currentTarget.querySelector('.scroll-list').style.animationPlayState = 'paused';
  };

  const startAutoScroll = (e) => {
    e.currentTarget.querySelector('.scroll-list').style.animationPlayState = 'running';
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <>
      {/* Section Header */}
      <div className="section-wrapper">
        <p className="section-subtitle">SHRI MULIKADEVI MAHAVIDYALAYA, NIGHOJ</p>
        <h2 className="section-title">📢 Campus News & Updates</h2>
        <p className="section-desc">
          Stay informed with the latest announcements, events, and updates.
        </p>
      </div>

      {/* Card Section */}
      <div className={`cards-section ${isVisible ? 'fade-in' : ''}`}>

        {/* Announcements */}
        <div className="homepage-info-card">
          <h3 className="card-title green">📢 Announcements</h3>
          <div
            className="scroll-box"
            onMouseEnter={!isMobile ? stopAutoScroll : undefined}
            onMouseLeave={!isMobile ? startAutoScroll : undefined}
          >
            <ul className="scroll-list">
              {announcements.length > 0 ? (
                announcements.map((item, idx) => (
                  <li className="hover-item" key={idx}>{item}</li>
                ))
              ) : (
                <li className="hover-item">No announcements</li>
              )}
            </ul>
          </div>
        </div>

        {/* Events */}
        <div className="homepage-info-card">
          <h3 className="card-title green">📅 Events</h3>
          <div
            className="scroll-box"
            onMouseEnter={!isMobile ? stopAutoScroll : undefined}
            onMouseLeave={!isMobile ? startAutoScroll : undefined}
          >
            <ul className="scroll-list">
              {events.length > 0 ? (
                events.map((item, idx) => (
                  <li className="hover-item" key={idx}>{item}</li>
                ))
              ) : (
                <li className="hover-item">No events</li>
              )}
            </ul>
          </div>
        </div>

        {/* Campus Updates */}
        <div className="homepage-info-card">
          <h3 className="card-title green">📌 Campus Updates</h3>
          <div
            className="scroll-box"
            onMouseEnter={!isMobile ? stopAutoScroll : undefined}
            onMouseLeave={!isMobile ? startAutoScroll : undefined}
          >
            <ul className="scroll-list">
              {updates.length > 0 ? (
                updates.map((item, idx) => (
                  <li className="hover-item" key={idx}>{item}</li>
                ))
              ) : (
                <li className="hover-item">No updates</li>
              )}
            </ul>
          </div>
        </div>

      </div>
    </>
  );
};

export default Cards;
